export default __webpack_public_path__ + "4db0aeaa9c4d69aa9dd381e993a975ac.jpg";